const hero = [
  'baby',
  'man-weight-lifting',
  'female-astronaut',
  'clapping-hands-sign',
  'male-student',
  'man-running',
  'fisted-hand-sign',
  'female-judge',
  'flexed-biceps',
  'male-technologist',
  'hand-with-index-and-middle-fingers-crossed',
  'male-health-worker',
  'breast-feeding',
  'ok-hand-sign',
  'man-dancing',
  'woman',
  'superhero',
  'nail-polish',
  'older-man',
  'golfer',
  'person-raising-both-hands-in-celebration',
  'shrug',
  'victory-hand',
  'person-doing-cartwheel',
]

const hands = [
  'i-love-you-hand-sign',
  'person-raising-both-hands-in-celebration',
  'thumbs-up-sign',
  'clapping-hands-sign',
  'ok-hand-sign',
  'hand-with-index-and-middle-fingers-crossed',
]

const faces = [
  'baby',
  'boy',
  'blonde-woman',
  'bearded-person',
  'older-woman',
  'older-man',
]

const professions = [
  'female-pilot',
  'male-judge',
  'female-health-worker',
  'male-mechanic',
  'female-teacher',
  'male-police-officer',
]

const activities = [
  'man-weight-lifting',
  'woman-biking',
  'man-rowing-boat',
  'woman-with-ball',
  'man-in-lotus-position',
  'woman-surfing',
]

const misc = [
  'selfie',
  'father-christmas',
  'merperson',
  'flexed-biceps',
  'woman-mage',
  'leg',
]

export const emojisByCat = {
  hero,
  hands,
  faces,
  professions,
  activities,
  misc,
}

export const emojisList = [
  ...new Set([].concat(...Object.values(emojisByCat))),
].sort()

export const emojisAll = [
  ['baby', '1f476'],
  ['child', '1f9d2'],
  ['boy', '1f466'],
  ['girl', '1f467'],
  ['adult', '1f9d1'],
  ['man', '1f468'],
  ['woman', '1f469'],
  ['older-adult', '1f9d3'],
  ['older-man', '1f474'],
  ['older-woman', '1f475'],
  ['male-health-worker', '1f468-200d-2695-fe0f'],
  ['female-health-worker', '1f469-200d-2695-fe0f'],
  ['male-student', '1f468-200d-1f393'],
  ['female-student', '1f469-200d-1f393'],
  ['male-teacher', '1f468-200d-1f3eb'],
  ['female-teacher', '1f469-200d-1f3eb'],
  ['male-judge', '1f468-200d-2696-fe0f'],
  ['female-judge', '1f469-200d-2696-fe0f'],
  ['male-farmer', '1f468-200d-1f33e'],
  ['female-farmer', '1f469-200d-1f33e'],
  ['male-cook', '1f468-200d-1f373'],
  ['female-cook', '1f469-200d-1f373'],
  ['male-mechanic', '1f468-200d-1f527'],
  ['female-mechanic', '1f469-200d-1f527'],
  ['male-factory-worker', '1f468-200d-1f3ed'],
  ['female-factory-worker', '1f469-200d-1f3ed'],
  ['male-office-worker', '1f468-200d-1f4bc'],
  ['female-office-worker', '1f469-200d-1f4bc'],
  ['male-scientist', '1f468-200d-1f52c'],
  ['female-scientist', '1f469-200d-1f52c'],
  ['male-technologist', '1f468-200d-1f4bb'],
  ['female-technologist', '1f469-200d-1f4bb'],
  ['male-singer', '1f468-200d-1f3a4'],
  ['female-singer', '1f469-200d-1f3a4'],
  ['male-artist', '1f468-200d-1f3a8'],
  ['female-artist', '1f469-200d-1f3a8'],
  ['male-pilot', '1f468-200d-2708-fe0f'],
  ['female-pilot', '1f469-200d-2708-fe0f'],
  ['male-astronaut', '1f468-200d-1f680'],
  ['female-astronaut', '1f469-200d-1f680'],
  ['male-firefighter', '1f468-200d-1f692'],
  ['female-firefighter', '1f469-200d-1f692'],
  ['police-officer', '1f46e'],
  ['male-police-officer', '1f46e-200d-2642-fe0f'],
  ['female-police-officer', '1f46e-200d-2640-fe0f'],
  ['sleuth-or-spy', '1f575'],
  ['male-sleuth', '1f575-fe0f-200d-2642-fe0f'],
  ['female-sleuth', '1f575-fe0f-200d-2640-fe0f'],
  ['guardsman', '1f482'],
  ['male-guard', '1f482-200d-2642-fe0f'],
  ['female-guard', '1f482-200d-2640-fe0f'],
  ['construction-worker', '1f477'],
  ['male-construction-worker', '1f477-200d-2642-fe0f'],
  ['female-construction-worker', '1f477-200d-2640-fe0f'],
  ['prince', '1f934'],
  ['princess', '1f478'],
  ['man-with-turban', '1f473'],
  ['man-wearing-turban', '1f473-200d-2642-fe0f'],
  ['woman-wearing-turban', '1f473-200d-2640-fe0f'],
  ['man-with-gua-pi-mao', '1f472'],
  ['person-with-headscarf', '1f9d5'],
  ['bearded-person', '1f9d4'],
  ['person-with-blond-hair', '1f471'],
  ['blond-man', '1f471-200d-2642-fe0f'],
  ['blonde-woman', '1f471-200d-2640-fe0f'],
  ['man-red-haired', '1f468-200d-1f9b0'],
  ['woman-red-haired', '1f469-200d-1f9b0'],
  ['man-curly-haired', '1f468-200d-1f9b1'],
  ['woman-curly-haired', '1f469-200d-1f9b1'],
  ['man-bald', '1f468-200d-1f9b2'],
  ['woman-bald', '1f469-200d-1f9b2'],
  ['man-white-haired', '1f468-200d-1f9b3'],
  ['woman-white-haired', '1f469-200d-1f9b3'],
  ['man-in-tuxedo', '1f935'],
  ['woman-in-tuxedo', '1f935-200d-2640-fe0f'],
  ['bride-with-veil', '1f470'],
  ['pregnant-woman', '1f930'],
  ['breast-feeding', '1f931'],
  ['baby-angel', '1f47c'],
  ['father-christmas', '1f385'],
  ['mother-christmas', '1f936'],
  ['superhero', '1f9b8'],
  ['woman-superhero', '1f9b8-200d-2640-fe0f'],
  ['man-superhero', '1f9b8-200d-2642-fe0f'],
  ['supervillain', '1f9b9'],
  ['woman-supervillain', '1f9b9-200d-2640-fe0f'],
  ['man-supervillain', '1f9b9-200d-2642-fe0f'],
  ['mage', '1f9d9'],
  ['woman-mage', '1f9d9-200d-2640-fe0f'],
  ['man-mage', '1f9d9-200d-2642-fe0f'],
  ['fairy', '1f9da'],
  ['woman-fairy', '1f9da-200d-2640-fe0f'],
  ['man-fairy', '1f9da-200d-2642-fe0f'],
  ['vampire', '1f9db'],
  ['woman-vampire', '1f9db-200d-2640-fe0f'],
  ['man-vampire', '1f9db-200d-2642-fe0f'],
  ['merperson', '1f9dc'],
  ['merwoman', '1f9dc-200d-2640-fe0f'],
  ['merman', '1f9dc-200d-2642-fe0f'],
  ['elf', '1f9dd'],
  ['woman-elf', '1f9dd-200d-2640-fe0f'],
  ['man-elf', '1f9dd-200d-2642-fe0f'],
  ['person-frowning', '1f64d'],
  ['man-frowning', '1f64d-200d-2642-fe0f'],
  ['woman-frowning', '1f64d-200d-2640-fe0f'],
  ['person-with-pouting-face', '1f64e'],
  ['man-pouting', '1f64e-200d-2642-fe0f'],
  ['woman-pouting', '1f64e-200d-2640-fe0f'],
  ['face-with-no-good-gesture', '1f645'],
  ['man-gesturing-not-ok', '1f645-200d-2642-fe0f'],
  ['woman-gesturing-not-ok', '1f645-200d-2640-fe0f'],
  ['face-with-ok-gesture', '1f646'],
  ['man-gesturing-ok', '1f646-200d-2642-fe0f'],
  ['woman-gesturing-ok', '1f646-200d-2640-fe0f'],
  ['information-desk-person', '1f481'],
  ['man-tipping-hand', '1f481-200d-2642-fe0f'],
  ['woman-tipping-hand', '1f481-200d-2640-fe0f'],
  ['happy-person-raising-one-hand', '1f64b'],
  ['man-raising-hand', '1f64b-200d-2642-fe0f'],
  ['woman-raising-hand', '1f64b-200d-2640-fe0f'],
  ['person-bowing-deeply', '1f647'],
  ['man-bowing-deeply', '1f647-200d-2642-fe0f'],
  ['woman-bowing-deeply', '1f647-200d-2640-fe0f'],
  ['face-palm', '1f926'],
  ['man-facepalming', '1f926-200d-2642-fe0f'],
  ['woman-facepalming', '1f926-200d-2640-fe0f'],
  ['shrug', '1f937'],
  ['man-shrugging', '1f937-200d-2642-fe0f'],
  ['woman-shrugging', '1f937-200d-2640-fe0f'],
  ['face-massage', '1f486'],
  ['man-getting-face-massage', '1f486-200d-2642-fe0f'],
  ['woman-getting-face-massage', '1f486-200d-2640-fe0f'],
  ['haircut', '1f487'],
  ['man-getting-haircut', '1f487-200d-2642-fe0f'],
  ['woman-getting-haircut', '1f487-200d-2640-fe0f'],
  ['pedestrian', '1f6b6'],
  ['man-walking', '1f6b6-200d-2642-fe0f'],
  ['woman-walking', '1f6b6-200d-2640-fe0f'],
  ['runner', '1f3c3'],
  ['man-running', '1f3c3-200d-2642-fe0f'],
  ['woman-running', '1f3c3-200d-2640-fe0f'],
  ['dancer', '1f483'],
  ['man-dancing', '1f57a'],
  ['person-in-steamy-room', '1f9d6'],
  ['woman-in-steamy-room', '1f9d6-200d-2640-fe0f'],
  ['man-in-steamy-room', '1f9d6-200d-2642-fe0f'],
  ['person-climbing', '1f9d7'],
  ['woman-climbing', '1f9d7-200d-2640-fe0f'],
  ['man-climbing', '1f9d7-200d-2642-fe0f'],
  ['person-in-lotus-position', '1f9d8'],
  ['woman-in-lotus-position', '1f9d8-200d-2640-fe0f'],
  ['man-in-lotus-position', '1f9d8-200d-2642-fe0f'],
  ['bath', '1f6c0'],
  ['sleeping-accommodation', '1f6cc'],
  ['man-in-business-suit-levitating', '1f574'],
  ['woman-in-business-suit-levitating', '1f574-fe0f-200d-2640-fe0f'],
  ['horse-racing', '1f3c7'],
  ['snowboarder', '1f3c2'],
  ['skier', '26f7'],
  ['golfer', '1f3cc'],
  ['man-golfing', '1f3cc-fe0f-200d-2642-fe0f'],
  ['woman-golfing', '1f3cc-fe0f-200d-2640-fe0f'],
  ['surfer', '1f3c4'],
  ['man-surfing', '1f3c4-200d-2642-fe0f'],
  ['woman-surfing', '1f3c4-200d-2640-fe0f'],
  ['rowboat', '1f6a3'],
  ['man-rowing-boat', '1f6a3-200d-2642-fe0f'],
  ['woman-rowing-boat', '1f6a3-200d-2640-fe0f'],
  ['swimmer', '1f3ca'],
  ['man-swimming', '1f3ca-200d-2642-fe0f'],
  ['woman-swimming', '1f3ca-200d-2640-fe0f'],
  ['person-with-ball', '26f9'],
  ['man-with-ball', '26f9-fe0f-200d-2642-fe0f'],
  ['woman-with-ball', '26f9-fe0f-200d-2640-fe0f'],
  ['weight-lifter', '1f3cb'],
  ['man-weight-lifting', '1f3cb-fe0f-200d-2642-fe0f'],
  ['woman-weight-lifting', '1f3cb-fe0f-200d-2640-fe0f'],
  ['bicyclist', '1f6b4'],
  ['man-biking', '1f6b4-200d-2642-fe0f'],
  ['woman-biking', '1f6b4-200d-2640-fe0f'],
  ['mountain-bicyclist', '1f6b5'],
  ['man-mountain-biking', '1f6b5-200d-2642-fe0f'],
  ['woman-mountain-biking', '1f6b5-200d-2640-fe0f'],
  ['person-doing-cartwheel', '1f938'],
  ['man-doing-cartwheel', '1f938-200d-2642-fe0f'],
  ['woman-doing-cartwheel', '1f938-200d-2640-fe0f'],
  ['water-polo', '1f93d'],
  ['man-playing-water-polo', '1f93d-200d-2642-fe0f'],
  ['woman-playing-water-polo', '1f93d-200d-2640-fe0f'],
  ['handball', '1f93e'],
  ['man-playing-handball', '1f93e-200d-2642-fe0f'],
  ['woman-playing-handball', '1f93e-200d-2640-fe0f'],
  ['juggling', '1f939'],
  ['man-juggling', '1f939-200d-2642-fe0f'],
  ['woman-juggling', '1f939-200d-2640-fe0f'],
  ['selfie', '1f933'],
  ['flexed-biceps', '1f4aa'],
  ['leg', '1f9b5'],
  ['foot', '1f9b6'],
  ['white-left-pointing-backhand-index', '1f448'],
  ['white-right-pointing-backhand-index', '1f449'],
  ['white-up-pointing-index', '261d'],
  ['white-up-pointing-backhand-index', '1f446'],
  ['reversed-hand-with-middle-finger-extended', '1f595'],
  ['white-down-pointing-backhand-index', '1f447'],
  ['victory-hand', '270c'],
  ['hand-with-index-and-middle-fingers-crossed', '1f91e'],
  ['raised-hand-with-part-between-middle-and-ring-fingers', '1f596'],
  ['sign-of-the-horns', '1f918'],
  ['call-me-hand', '1f919'],
  ['raised-hand-with-fingers-splayed', '1f590'],
  ['raised-hand', '270b'],
  ['ok-hand-sign', '1f44c'],
  ['thumbs-up-sign', '1f44d'],
  ['thumbs-down-sign', '1f44e'],
  ['raised-fist', '270a'],
  ['fisted-hand-sign', '1f44a'],
  ['left-facing-fist', '1f91b'],
  ['right-facing-fist', '1f91c'],
  ['raised-back-of-hand', '1f91a'],
  ['waving-hand-sign', '1f44b'],
  ['i-love-you-hand-sign', '1f91f'],
  ['writing-hand', '270d'],
  ['clapping-hands-sign', '1f44f'],
  ['open-hands-sign', '1f450'],
  ['person-raising-both-hands-in-celebration', '1f64c'],
  ['palms-up-together', '1f932'],
  ['person-with-folded-hands', '1f64f'],
  ['nail-polish', '1f485'],
  ['ear', '1f442'],
  ['nose', '1f443'],
]



// WEBPACK FOOTER //
// ./src/util.js